<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col-sm-4">
        <h5 class="modal-title">User Detail</h5>
      </div>
      <div class="col-sm-8 btn-holder text-right">
        <button
          *ngIf="!isOwner(user)"
          (click)="onResetPassword()"
          matTooltip="Send password reset email to this user."
          matTooltipClass="text-center"
          matTooltipPosition="below"
          type="button"
          class="btn btn-cst-warning2 text-uppercase"
        >
          <i class="fal fa-key"></i>
          Reset Password
        </button>
        <button *ngIf="!isCurrentUser" (click)="onDelete()" type="button" class="btn btn-danger text-uppercase">
          <span class="fal fa-trash-alt"></span>
          Delete
        </button>
        <button (click)="onSave(form)" type="button" class="btn btn-success text-uppercase">
          <span class="fal fa-save"></span>
          Save
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="fas fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="sidebar-lhs">
          <div class="profile-img-holder">
            <div class="profile-img">
              <span class="avater-cst-magenta">{{ user.name | initials }}</span>
            </div>
            <div class="profile-content">
              <h2 class="title">{{ user.firstName }} {{ user.lastName }}</h2>
              <h4 class="subtitle">{{ user.roleView }}</h4>
            </div>
          </div>

          <!-- User Information -->
          <form [formGroup]="infoForm" class="box">
            <div class="box-head">
              <a (click)="hideBasicInfo = !hideBasicInfo" role="button">
                <i class="far left-icon fa-user-circle"></i>
                <span>User Information</span>
                <i
                  class="fas chevron"
                  [ngClass]="{ 'fa-chevron-up': !hideBasicInfo, 'fa-chevron-down': hideBasicInfo }"
                ></i>
              </a>
              <a href="javascript:;" class="side-bg">
                <img src="../assets/images/icons/vc-rental.png" alt="" />
              </a>
            </div>
            <div class="box-body collapse" [ngClass]="{ show: !hideBasicInfo }">
              <div class="row no-margin">
                <div class="col-sm-12">
                  <mat-form-field class="mat-block">
                    <input
                      type="text"
                      formControlName="firstName"
                      matInput
                      required
                      placeholder="First Name"
                      autocomplete="off"
                    />
                    <mat-error
                      *ngIf="infoForm.get('firstName').touched && infoForm.get('firstName').hasError('required')"
                    >
                      First Name is <strong>required</strong>
                    </mat-error>
                    <mat-error
                      *ngIf="infoForm.get('firstName').touched && infoForm.get('firstName').hasError('allNumbers')"
                    >
                      First Name cannot be numbers alone.
                    </mat-error>
                    <mat-error
                      *ngIf="infoForm.get('firstName').touched && infoForm.get('firstName').hasError('minlength')"
                    >
                      First Name must be at least <strong>2</strong> characters long
                    </mat-error>
                    <mat-error
                      *ngIf="infoForm.get('firstName').touched && infoForm.get('firstName').hasError('maxlength')"
                    >
                      First Name must be at most <strong>50</strong> characters long
                    </mat-error>
                    <mat-error *ngIf="infoForm.get('firstName').hasError('name')">
                      Only alphanumeric value is allowed.
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12">
                  <mat-form-field class="mat-block">
                    <input
                      type="text"
                      formControlName="lastName"
                      matInput
                      required
                      placeholder="Last Name"
                      autocomplete="off"
                    />
                    <mat-error
                      *ngIf="infoForm.get('lastName').touched && infoForm.get('lastName').hasError('required')"
                    >
                      Last Name is <strong>required</strong>
                    </mat-error>
                    <mat-error
                      *ngIf="infoForm.get('lastName').touched && infoForm.get('lastName').hasError('allNumbers')"
                    >
                      Last Name cannot be numbers alone.
                    </mat-error>
                    <mat-error
                      *ngIf="infoForm.get('lastName').touched && infoForm.get('lastName').hasError('minlength')"
                    >
                      Last Name must be at least <strong>2</strong> characters long
                    </mat-error>
                    <mat-error
                      *ngIf="infoForm.get('lastName').touched && infoForm.get('lastName').hasError('maxlength')"
                    >
                      Last Name must be at most <strong>50</strong> characters long
                    </mat-error>
                    <mat-error *ngIf="infoForm.get('lastName').hasError('name')">
                      Only alphanumeric value is allowed.
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12">
                  <mat-form-field class="mat-block">
                    <input
                      type="email"
                      formControlName="email"
                      matInput
                      required
                      placeholder="Email"
                      autocomplete="off"
                    />
                    <mat-error *ngIf="infoForm.get('email').touched && infoForm.get('email').hasError('required')">
                      Email is <strong>required</strong>
                    </mat-error>
                    <mat-error *ngIf="infoForm.get('email').touched && infoForm.get('email').hasError('email')">
                      Email must have valid format
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12">
                  <app-national-phone-input2 [ctrl]="infoForm.get('phone')"></app-national-phone-input2>
                </div>
                <div class="col-sm-12">
                  <mat-form-field class="mat-block">
                    <mat-select formControlName="role" placeholder="User Role" [required]="true">
                      <mat-option
                        *ngFor="let role of roles$ | async"
                        [value]="role.value"
                        [matTooltip]="role.tooltip"
                        matTooltipPosition="right"
                        matTooltipClass="text-center"
                        >{{ role.label }}</mat-option
                      >
                    </mat-select>
                    <mat-error *ngIf="infoForm.get('role').touched && infoForm.get('role').hasError('required')">
                      User Role is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-12" formGroupName="attributes">
                  <mat-form-field class="mat-block">
                    <mat-select formControlName="gender" placeholder="Gender">
                      <mat-option *ngFor="let gender of genders" [value]="gender.id">{{ gender.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-12">
                  <app-select-search
                    [items]="languages"
                    [ctrl]="infoForm.get('attributes').get('language')"
                    [multiple]="false"
                    bindValue="id"
                    bindLabel="name"
                    placeholder="Language"
                  ></app-select-search>
                </div>
              </div>
            </div>
          </form>

          <!-- User Location -->
          <form [formGroup]="locationForm" class="box">
            <div class="box-head">
              <a (click)="hideAddress = !hideAddress" role="button">
                <i class="far left-icon fa-map"></i>
                <span>User Location</span>
                <i
                  class="fas chevron"
                  [ngClass]="{ 'fa-chevron-up': !hideAddress, 'fa-chevron-down': hideAddress }"
                ></i>
              </a>
            </div>
            <div class="box-body collapse" [ngClass]="{ show: !hideAddress }">
              <div class="row no-margin">
                <div class="col-sm-12">
                  <mat-form-field *ngIf="isGoogleLoaded" class="mat-block">
                    <input
                      appGooglePlaces
                      (onAddressChange)="onPlaceChange($event)"
                      type="text"
                      formControlName="address"
                      matInput
                      placeholder="Address"
                    />
                    <mat-error
                      *ngIf="locationForm.get('address').touched && locationForm.get('address').hasError('minlength')"
                    >
                      Address must be at least <strong>2</strong> characters long
                    </mat-error>
                    <mat-error
                      *ngIf="locationForm.get('address').touched && locationForm.get('address').hasError('maxlength')"
                    >
                      Address must be at most <strong>140</strong> characters long
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field *ngIf="!isGoogleLoaded" class="mat-block">
                    <input type="text" formControlName="address" matInput placeholder="Address" />
                    <mat-error
                      *ngIf="locationForm.get('address').touched && locationForm.get('address').hasError('minlength')"
                    >
                      Address must be at least <strong>2</strong> characters long
                    </mat-error>
                    <mat-error
                      *ngIf="locationForm.get('address').touched && locationForm.get('address').hasError('maxlength')"
                    >
                      Address must be at most <strong>140</strong> characters long
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12">
                  <mat-form-field class="mat-block">
                    <input type="text" formControlName="city" matInput placeholder="City" />
                    <mat-error
                      *ngIf="locationForm.get('city').touched && locationForm.get('city').hasError('minlength')"
                    >
                      City must be at least <strong>2</strong> characters long
                    </mat-error>
                    <mat-error
                      *ngIf="locationForm.get('city').touched && locationForm.get('city').hasError('maxlength')"
                    >
                      City must be at most <strong>50</strong> characters long
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12">
                  <app-select-search
                    [items]="countryList"
                    [ctrl]="locationForm.get('country')"
                    [multiple]="false"
                    bindValue="id"
                    bindLabel="name"
                    placeholder="Country"
                  ></app-select-search>
                </div>
                <div class="col-sm-12">
                  <mat-form-field class="mat-block">
                    <input type="text" formControlName="state" matInput placeholder="State / Province / Region" />
                    <mat-error
                      *ngIf="locationForm.get('state').touched && locationForm.get('state').hasError('minlength')"
                    >
                      Value must be at least <strong>2</strong> characters long
                    </mat-error>
                    <mat-error
                      *ngIf="locationForm.get('state').touched && locationForm.get('state').hasError('maxlength')"
                    >
                      Value must be at most <strong>50</strong> characters long
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-12">
                  <mat-form-field class="mat-block">
                    <input type="text" formControlName="postalCode" matInput placeholder="Postal Code" />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-content-holder">
          <div class="content">
            <div class="row no-margin header">
              <div class="col-lg-8 nav-holder">
                <div class="nav nav-tabs">
                  <a
                    (click)="currentTab$.next('settings')"
                    class="nav-item nav-link"
                    [class.active]="currentTab$.value === 'settings'"
                  >
                    <i class="fal fa-cog"></i>
                    User Settings
                  </a>
                  <a
                    *ngIf="canRestrictRentals() && !isCurrentUser"
                    (click)="currentTab$.next('rentals')"
                    matTooltip="Select the rentals which this user will be restricted from accessing."
                    matTooltipClass="text-center"
                    matTooltipPosition="above"
                    class="nav-item nav-link"
                    [class.active]="currentTab$.value === 'rentals'"
                  >
                    <i class="fal fa-ban"></i>
                    Restricted Rentals
                  </a>
                  <a
                    *ngIf="isOwner(user) && !isCurrentUser"
                    (click)="currentTab$.next('ownerRentals')"
                    matTooltip="Select the rentals which will be visible for this owner."
                    matTooltipClass="text-center"
                    matTooltipPosition="above"
                    class="nav-item nav-link"
                    [class.active]="currentTab$.value === 'ownerRentals'"
                  >
                    <i class="fal fa-key"></i>
                    Owner Rentals
                  </a>
                </div>
              </div>
              <div class="col-lg-4 btn-holder">
                <app-table-search
                  (search)="onSearchRental($event)"
                  [hideClearFilterBtn]="true"
                  *ngIf="currentTab$.value === 'rentals' || currentTab$.value === 'ownerRentals'"
                >
                </app-table-search>
              </div>
            </div>

            <div class="tab-content">
              <div class="tab-pane" [class.active]="currentTab$.value === 'settings'">
                <form [formGroup]="preferenceForm" class="preference-form" *ngIf="!isCurrentUser">
                  <div class="row">
                    <div class="col-sm-4">
                      <mat-checkbox
                        matTooltip="Disabled users cannot login to Tokeet or any of the Tokeet add-on applications."
                        matTooltipClass="text-center"
                        matTooltipPosition="above"
                        formControlName="disabled"
                      >
                        Disable Tokeet Login
                      </mat-checkbox>
                    </div>
                    <div *ngIf="canEnableAutomata()" class="col-sm-4">
                      <mat-checkbox
                        matTooltip="Enable this user to login to Automata."
                        matTooltipClass="text-center"
                        matTooltipPosition="above"
                        formControlName="automata"
                      >
                        Enable Automata Login
                      </mat-checkbox>
                    </div>
                    <div *ngIf="canEnableSignature()" class="col-sm-4">
                      <mat-checkbox
                        matTooltip="Enable this user to login to Signature."
                        matTooltipClass="text-center"
                        matTooltipPosition="above"
                        formControlName="signature"
                      >
                        Enable Signature Login
                      </mat-checkbox>
                    </div>
                    <div *ngIf="canEnableOwnerCenter()" class="col-sm-4">
                      <mat-checkbox
                        matTooltip="Enable this user to login to Owner Center."
                        matTooltipClass="text-center"
                        matTooltipPosition="above"
                        formControlName="ownercenter"
                      >
                        Enable Owner <span *ngIf="isOwner(user)">Portal</span
                        ><span *ngIf="!isOwner(user)">Center</span> Login
                      </mat-checkbox>
                    </div>
                    <div *ngIf="canEnableRategenie()" class="col-sm-4">
                      <mat-checkbox
                        matTooltip="Enable this user to login to Rategenie."
                        matTooltipClass="text-center"
                        matTooltipPosition="above"
                        formControlName="rategenie"
                      >
                        Enable Rategenie Login
                      </mat-checkbox>
                    </div>
                    <div *ngIf="canEnableWebready()" class="col-sm-4">
                      <mat-checkbox
                        matTooltip="Enable this user to login to Webready."
                        matTooltipClass="text-center"
                        matTooltipPosition="above"
                        formControlName="webready"
                      >
                        Enable Webready Login
                      </mat-checkbox>
                    </div>
                    <div *ngIf="canEnableChecklist()" class="col-sm-4">
                      <mat-checkbox
                        matTooltip="Enable this user to login to Checklist."
                        matTooltipClass="text-center"
                        matTooltipPosition="above"
                        formControlName="checklist"
                      >
                        Enable Checklist Login
                      </mat-checkbox>
                    </div>
                    <div *ngIf="isOwner(user)" class="col-sm-4">
                      <mat-checkbox
                        [matTooltip]="
                          !!preferenceForm.get('total').value
                            ? 'Uncheck this field to hide booking charges from owner'
                            : 'Check this field for showing booking charges to owner'
                        "
                        matTooltipClass="text-center"
                        matTooltipPosition="above"
                        formControlName="total"
                      >
                        Show Charge Details
                      </mat-checkbox>
                    </div>
                    <div *ngIf="(aiResponderSub$ | async)?.isValid" class="col-sm-4">
                      <mat-checkbox
                        [matTooltip]="
                          !!preferenceForm.get('ai_settings').value
                            ? 'Uncheck this field to hide AI settings from user'
                            : 'Check this field for showing AI settings to user'
                        "
                        matTooltipClass="text-center"
                        matTooltipPosition="above"
                        formControlName="ai_settings"
                      >
                        Enable TokeetAI feature
                      </mat-checkbox>
                    </div>
                  </div>
                  <app-staff-permissions [user]="user" *ngIf="isStaff(user)"></app-staff-permissions>
                </form>
                <form [formGroup]="mfaForm" class="preference-form" *ngIf="isCurrentAdmin || isCurrentUser">
                  <hr *ngIf="!isCurrentUser" />
                  <div class="text-bold">Multi-Factor Authentication (MFA) Configuration</div>
                  <div class="alert alert-warning mt-3" *ngIf="isAccountMFAEnabled$ | async">
                    MFA has been enabled for all users in this account by an administrator. Once account level MFA is
                    enabled your user level MFA checkbox is ignored. However, you may still select your delivery method.
                  </div>

                  <div class="mt-3">
                    <mat-checkbox
                      formControlName="status"
                      class="mb-3"
                      [matTooltip]="
                        isCurrentUser
                          ? 'Use below Configure MFA Button to edit MFA settings for yourself'
                          : 'User can only enable MFA for their own account.'
                      "
                      >Enable MFA</mat-checkbox
                    >
                  </div>
                  <div class="">
                    <mat-form-field>
                      <mat-select formControlName="delivery" placeholder="Delivery Method">
                        <mat-option [value]="item.id" *ngFor="let item of mfaDeliveryMethodOptions">{{
                          item.label
                        }}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <button
                      (click)="onResetTotp()"
                      type="button"
                      class="btn btn-cst-danger ml-3 text-uppercase"
                      matTooltip="You need to remove your account from the Authenticator App as well after deregister your device from here."
                      matTooltipPosition="above"
                      *ngIf="isCurrentUser && isTotpSelected && (isTotpDeviceRegistered$ | async)"
                    >
                      <i class="far fa-unlink"></i>
                      Deregister auth device
                    </button>
                  </div>
                  <button class="btn btn-cst-info" (click)="onConfigMFA()" *ngIf="isCurrentUser">
                    <i class="far fa-cog"></i> Configure MFA
                  </button>
                </form>
              </div>

              <div class="tab-pane" [class.active]="currentTab$.value === 'rentals'">
                <div class="table-holder table-responsive" [class.loading-section]="isRestrictingUsers$ | async">
                  <table class="table table-default table-striped">
                    <mat-table #table matSort [dataSource]="rentalDataSource">
                      <ng-container matColumnDef="select">
                        <mat-header-cell *matHeaderCellDef>
                          <mat-checkbox
                            (change)="onToggleRestrictedAll($event)"
                            [checked]="rentals | isAllRestricted : user"
                          >
                          </mat-checkbox>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                          <mat-checkbox
                            (click)="$event.stopPropagation()"
                            (change)="onToggleRestricted($event, row)"
                            [checked]="row | isRestricted : user"
                          >
                          </mat-checkbox>
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Name</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                          <span [matTooltip]="element.name" matTooltipPosition="above" matTooltipClass="text-center">{{
                            element.name | truncate : 45
                          }}</span>
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="description">
                        <mat-header-cell *matHeaderCellDef> Description</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                          <td class="desc">
                            <i class="fas fa-bed"></i>
                            <strong>{{ element.bedrooms || 0 }}</strong>
                            <span class="sptr">|</span>
                            <i class="fas fa-bath"></i>
                            <strong>{{ element.bathrooms || 0 }}</strong>
                            <span class="sptr">|</span>
                            <span>{{ element.type }}</span>
                          </td>
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="phone">
                        <mat-header-cell *matHeaderCellDef> Phone</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                          <span [matTooltip]="element.phone" matTooltipPosition="above" matTooltipClass="text-center">{{
                            element.phone | truncate : 16
                          }}</span></mat-cell
                        >
                      </ng-container>

                      <ng-container matColumnDef="cityView">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>City</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                          <span
                            [matTooltip]="element.cityView"
                            matTooltipPosition="above"
                            matTooltipClass="text-center"
                            >{{ element.cityView | truncate : 16 }}</span
                          >
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="countryView">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Country</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                          <span
                            [matTooltip]="element.countryView"
                            matTooltipPosition="above"
                            matTooltipClass="text-center"
                            >{{ element.countryView | truncate : 16 }}</span
                          >
                        </mat-cell>
                      </ng-container>

                      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                    </mat-table>

                    <mat-paginator
                      #paginator
                      [length]="rentalDataSource?.data?.length"
                      [class.hidden]="isEmptyTable$ | async"
                      [pageSize]="10"
                      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
                      [showFirstLastButtons]="true"
                    >
                    </mat-paginator>

                    <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType"></app-empty-table>
                  </table>
                </div>
              </div>

              <div *ngIf="isOwner(user)" class="tab-pane" [class.active]="currentTab$.value === 'ownerRentals'">
                <app-owner-rentals [ownerId]="user.id" [searchTerm]="ownerRentalsSearchTerm"></app-owner-rentals>
              </div>

              <div *ngIf="!isCurrentUser && !isCurrentAdmin" class="tab-pane active">
                <div class="current-user-box">
                  <i class="fal fa-ban"></i>
                  <h5>You cannot update settings for your own user account.</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
